import React from 'react';
import { useState } from 'react';
import { Popover, Tooltip } from '@mantine/core';
// import Deletechat from './deletechat';
import { useWindowSize } from 'react-use';
import useUpdateMailStatus from '../hooks/useUpdateMailStatus';
import Composemail from './Composemail';

const Popovermenu = ({ icon, mail, setIsUpdated }) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { width } = useWindowSize();
  // console.log('mail', mail);

  //popover size
  function modelsize() {
    if (width >= 1280 && width <= 1535) {
      return 'lg';
    } else if (width >= 1536) {
      return 'xl';
    } else {
      return 'lg';
    }
  }
  const size1 = modelsize();
  const useupdateMailStatus = useUpdateMailStatus();

  return (
    <div>
      <Popover
        opened={isMenuOpened}
        onClose={() => setIsMenuOpened(false)}
        target={
          <div className='px-1 cursor-pointer'>
            <img
              src={icon}
              alt='menu'
              className='cursor-pointer px-1 w-6 h-4 2xl:w-7 2xl:h-5 3xl:w-8 3xl:h-6'
              onClick={() => {
                setIsMenuOpened(true);
              }}
            />
          </div>
        }
        width={size1}
        position='bottom-end'
      >
        <div className='bg-FFFFFF font-normal text-000000 text-sm 2xl:text-lg 3xl:text-2xl w-32 2xl:w-40 3xl:w-48'>
          <p
            className='p-1.5 cursor-pointer  hover:bg-F8F7F7'
            onClick={() => {
              setIsModalOpen(true);
              setIsMenuOpened(false);
            }}
          >
            Reply
          </p>

          {
            // Mark as read should not  be displayed  for draft mails
            <p
              className={`${
                mail?.mail_type === 'Draft' ? 'hidden' : ''
              } p-1.5 cursor-pointer  hover:bg-F8F7F7`}
              onClick={() => {
                useupdateMailStatus.mutate({
                  id: mail?.id,
                  read: mail?.is_read ? false : true,
                });
                setIsUpdated((prev) => !prev);
                setIsMenuOpened(false);
              }}
            >
              {mail?.is_read ? 'Mark as unread' : 'Mark as read'}
            </p>
          }
          <p
            className='p-1.5 cursor-pointer  hover:bg-F8F7F7'
            onClick={() => {
              setIsMenuOpened(false);
              useupdateMailStatus.mutate({
                id: mail?.id,
                pin: !mail?.is_pinned,
              });
            }}
          >
            {mail?.is_pinned ? 'Unpin' : 'Pin'}
          </p>
          <p
            className='p-1.5 cursor-pointer hover:bg-F8F7F7'
            onClick={() => {
              setIsMenuOpened(false);
              useupdateMailStatus.mutate({
                id: mail?.id,
                save: !mail?.is_saved,
              });
            }}
          >
            {mail?.is_saved ? 'Unsave' : 'Save'}
          </p>

          {
            // Delete option should be not displayed for deleted mails

            mail?.mail_type !== 'Deleted' && (
              <Tooltip
                label='will be moved to delete folder'
                classNames={{
                  body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
                }}
                radius='md'
              >
                <p
                  className='p-1.5 cursor-pointer  hover:bg-F8F7F7'
                  onClick={() => {
                    setIsMenuOpened(false);
                    setIsUpdated((prev) => !prev);
                    useupdateMailStatus.mutate({
                      id: mail?.id,
                      delete: true,
                    });
                  }}
                >
                  Delete
                </p>
              </Tooltip>
            )
          }

          <p
            className='p-1.5 cursor-pointer  hover:bg-F8F7F7'
            onClick={() => {
              setIsMenuOpened(false);
              useupdateMailStatus.mutate({
                id: mail?.id,
                archive: !mail?.mail_type? false:true,
              });
            }}
          >
           
            {mail?.mail_type === 'Archive' ? 'Unarchive' : 'Archive'}
          </p>
          {/*    <p className='p-2 mt-2 2xl:mt-4 3xl:mt-5 cursor-not-allowed  hover:bg-F8F7F7'>
            Block sender
          </p> */}
        </div>
      </Popover>
      {/*{' '}
      <Deletechat
        isModalOpen={isDeleteModalOpen}
        setIsModalOpen={setDeleteModalOpen}
        id={mail?.id}
      />{' '}
      */}
      {
        <Composemail
          opened={isModalOpen}
          setOpened={setIsModalOpen}
          action='reply'
          data={mail}
        />
      }
    </div>
  );
};

export default Popovermenu;
